import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const fallback = 'https://images.unsplash.com/photo-1520340356584-f9917d1eea6f?auto=format&fit=crop&w=800&q=80';

// Home "shop by category" card — image + name only, lands on the
// products page pre-filtered to this category.
export default function CategoryCard({ category, index = 0 }) {
  return (
    <motion.div
      style={{ height: '100%' }}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-40px' }}
      transition={{ duration: 0.5, delay: (index % 4) * 0.06 }}
    >
      <Link to={`/products?category=${category.slug || category._id}`} className="ccard">
        <div className="ccard__media">
          <img src={category.image || fallback} alt={category.name} loading="lazy" />
          <div className="ccard__scrim" />
          <div className="ccard__body">
            <h3>{category.name}</h3>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
